import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt-PT';
import { environment } from '../environments/environment';
registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    LayoutModule,
    HttpModule,
    HttpClientModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: 'BASE_URL', useValue: environment.apiUrl },
    { provide: 'ID_SITE', useValue: environment.idSite },
    { provide: 'ID_SETOR', useValue: environment.idSetor },
    { provide: 'CMS_HOST', useValue: environment.host }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
